import type { ReactNode } from 'react'

import {
  IconFilter,
  WithPopover,
  type WithPopoverChildrenProps,
} from '@procurify/ui'
import { isFunction } from 'lodash'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { FilterButtonStyled } from './styles/FilterButtonStyled'
import { FiltersPopoverContentStyled } from './styles/FiltersPopoverContentStyled'

export interface IFiltersPopoverProps {
  children?: ((args: WithPopoverChildrenProps) => ReactNode) | ReactNode
}

export const FiltersPopover = ({ children }: IFiltersPopoverProps) => {
  const intl = useProcurifyIntl()

  return (
    <WithPopover
      trigger='click'
      placement='bottom'
      content={(props) => (
        <FiltersPopoverContentStyled>
          {isFunction(children) ? children(props) : children}
        </FiltersPopoverContentStyled>
      )}
    >
      <FilterButtonStyled iconComponent={<IconFilter />}>
        {intl.formatMessage(messages.buttonText)}
      </FilterButtonStyled>
    </WithPopover>
  )
}
